module.exports = new __parcel__URL__("x.b9a06a50.svg").toString();